import { createSelector } from 'reselect';
import { HVAC_AREA_LIST } from 'src/modules/hvac/constants/area';
import { getHvacAssesmentFormData } from 'src/modules/hvac/selectors/getHvacAssesmentFormData';
import { getHvacFormCounters } from 'src/modules/hvac/selectors/getHvacFormCounters';

export const getHvacResultsIncompleteResults = createSelector([
  getHvacFormCounters,
  getHvacAssesmentFormData,
], (counters, formData): boolean => HVAC_AREA_LIST
  .filter((area) => formData.areas[area].enabled)
  .some((area) => (
    // enabled at least one section
    counters[area].enabled > 0 &&
    // enabled less than 5 sections
    counters[area].enabled < 5 &&
    // all enabled sections answered
    counters[area].enabled === counters[area].answered
  )));
